import { Component, ViewChild, ElementRef, QueryList, ViewChildren } from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime, map, takeUntil, last, tap } from 'rxjs/operators';
import { SearchDocuments } from './_store/resources.actions';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { MatDialog, MatDialogRef, MatTabNav, MatTabLink, PageEvent, MatPaginator } from '@angular/material';
import { CreateFolderComponent } from './create-folder/create-folder.component'
import { Router, ActivatedRoute } from '@angular/router';


import { ViewListService } from "../../../services/list-grid-view.service";
import { Subject } from 'rxjs';
import { LoaderShow, LoaderHide } from '../../loader/store/loader.actions';
import { PAGE_LIMIT } from 'src/app/app.constants';




@Component({
    selector: 'app-resources',
    templateUrl: './resources.component.html',
    styleUrls: ['./resources.component.scss']
})
export class ResourcesComponent {
    folderId: string
    searchInput = new FormControl();
    searchResults$;
    showSearchResults: boolean = false;
    myFilesPageNumber: number = 1;
    master = 'Master';
    private stopper$: Subject<void> = new Subject<void>();
    @ViewChild('tabs', { static: false }) tab: MatTabNav;
    @ViewChildren(MatTabLink) linkElements: QueryList<MatTabLink>;
    myDocuments: boolean = true;
    showAddButton: boolean = true;
    sortOption: string = 'name'

    isGrid = false;
    totalPagesInSearchResult: number = 0;
    searchString: string;
    count: any;
    currentPage: number = 0;

    limitPerPageOptions;
    pageSizeDefault = '30';
    pageLimit = this.pageSizeDefault;


    @ViewChild('paginator', { static: false })
    paginator: MatPaginator;

    @ViewChild('searchDoc', { static: false })
    searchDoc: any;

    constructor(private store: Store<AppState>, private dialog: MatDialog, private router: Router, private activatedRoute: ActivatedRoute, private viewData: ViewListService) {
        this.limitPerPageOptions = PAGE_LIMIT;


        this.viewData.CurrentShowFlag.subscribe(flag => {
            this.myDocuments = flag
        })

        this.searchInput.valueChanges.pipe(debounceTime(1000)).subscribe(searchString => {
            this.searchString = searchString;
            this.showSearchResults = searchString && searchString.length > 0;
            this.myFilesPageNumber = 1;
            if (this.paginator) {
                this.paginator.pageIndex = 0;
            }
            this.store.dispatch(new SearchDocuments(searchString, { page: 1, limit: this.pageLimit }, true));
        });

        this.searchResults$ = this.store.select(state => state.resources.docSearchResults).pipe(takeUntil(this.stopper$), tap((resp) => { console.log(resp, "rese") })).pipe(map((searchResult: any) => {
            if (Object.keys(searchResult).length) {
                this.store.dispatch(new LoaderHide());
                this.totalPagesInSearchResult = searchResult.pages;
                this.count = searchResult.total;
                this.currentPage = searchResult.page;
                this.pageLimit = this.pageSizeDefault;
                if (this.searchDoc) {
                    this.searchDoc.nativeElement.scrollTop = 0;
                }
            }
            return searchResult['docs'];
        }))
        this.store.select(state => state.auth).subscribe(auth => {
            if (auth.user && auth.user.capabilities && (auth.user.capabilities).length) {
                let capabilities = auth.user.capabilities;
                this.showAddButton = (capabilities.includes('create-doc') && capabilities.includes('create-doc')) ? true : false;
                if (this.showAddButton) {


                }

            }
        });
        this.viewData.currentViewMode.subscribe(viewMode => {
            this.isGrid = viewMode;
        })

    }

    changeListView(viewFlag: boolean = false) {
        this.viewData.changeView(viewFlag)
    }

    onTabSelected(event) {
        this.showSearchResults = false;
    }

    openCreateFolderDialog(type) {
        if (type === "my") {
            let folderId
            this.activatedRoute.firstChild.params.subscribe(param => folderId = param.id)

            const dialogref = this.dialog.open(CreateFolderComponent, {
                hasBackdrop: true,
                width: '700px',
                panelClass: 'task-detail-modal',
                data: {
                    alertTitle: 'Create Folder',
                    folderIdParam: folderId ? folderId : '',
                    type: type
                }
            })
        }
        else if (type === "citiis") {
            let folderId
            this.activatedRoute.firstChild.params.subscribe(param => folderId = param.id)

            const dialogref = this.dialog.open(CreateFolderComponent, {
                hasBackdrop: true,
                width: '700px',
                panelClass: 'task-detail-modal',
                data: {
                    alertTitle: 'Create CITIIS Folder',
                    folderIdParam: folderId ? folderId : '',
                    type: type
                }
            })
        }
    }

    editTemplate() {
        this.activatedRoute.firstChild.params.subscribe(param => this.folderId = param.id)
        if (this.folderId) {
            if(this.router.url.includes('citis')){
                this.router.navigate(['/home/resources/upload-document/citiis', this.folderId]);
            }else{
                this.router.navigate(['/home/resources/upload-document', this.folderId]);
            }
        }
        else {
            this.router.navigate(['/home/resources/upload-document', '']);
        }

    }
    ngOnInit() {
        // this.activatedRoute.url.subscribe((resp) => {
        //     console.log(resp)
        // })
        // console.log(this.router.getCurrentNavigation())
    }


    linkClicked(value) {
        this.viewData.showNewButton(value)
    }
    ngAfterViewInit() {

        // console.log(this.tab, "each link")
        this.linkElements.toArray().forEach((link: any) => {
            // console.log(link, "here")
        })
    }
    onScrollSearch(event) {
        const divViewHeight = event.target.offsetHeight; // viewport: ~500px
        const divScrollHeight = event.target.scrollHeight; // length of all table
        const scrollLocation = event.target.scrollTop; // how far user scrolled
        const buffer = 0;
        const limit = divScrollHeight - divViewHeight - buffer;

        //for my messages
        if (scrollLocation >= limit) {
            if (this.myFilesPageNumber < this.totalPagesInSearchResult) {
                this.myFilesPageNumber++;
                this.store.dispatch(new SearchDocuments(this.searchString, { page: this.myFilesPageNumber, limit: this.pageLimit }, true));
            }

        }
    }

    getServerData(event?: PageEvent) {
        this.store.dispatch(new LoaderShow());
        this.store.dispatch(new SearchDocuments(this.searchString, { page: event, limit: this.pageLimit }, true));
        // this.store.dispatch(new GetSharedDocuments({ 'page': event.pageIndex + 1, 'limit': 30 }));
    }

    onChange(event) {
        this.store.dispatch(new LoaderShow());
        this.store.dispatch(new SearchDocuments(this.searchString, { page: 1, limit: event.value }, true));
    }

    clearSearch() {
        this.searchInput.setValue("");
    }

    ngOnDestroy() {
        this.stopper$.next();
    }

    isShowButtons() {
        // if (this.checkPermissions('create-doc')) {
            if (this.router.url.includes('citis')) {
                return this.checkPermissions('upload-doc-to-citiis-folder');
            } else {
                return this.checkPermissions('create-doc')
            }
        // } else {
        //     return false
        // }

    }

    checkPermissions(type) {
        let isAllow = false;
        this.store.select(state => state.auth.user['capabilities']).subscribe(response => {
            if (response.length) {
                const capabilities = (response || []).reduce((acc, item) => {
                    return [...acc, ...item.capabilities];
                }, []);
                if (capabilities.includes(type)) {
                    isAllow = true
                } else {
                    isAllow = false;
                }
            }
        });
        return isAllow;
    }

    canViewCreate(){
        // return true;
        let foldId;
        this.activatedRoute.firstChild.params.subscribe(param => foldId = param.id);
        if (this.router.url.includes('citis')) {
            return this.checkPermissions('create-citiis-folder');
        }else if(foldId && (!this.router.url.includes('citis'))){
            return false;
        }else{
            return this.checkPermissions('create-citiis-folder')
        }

    }

    canViewCreateMyFolder(){
        // return true;
        let foldId;
        this.activatedRoute.firstChild.params.subscribe(param => foldId = param.id);
        if (this.router.url.includes('citis')) {
            return false;
        }else if(foldId && (!this.router.url.includes('citis'))){
            return this.checkPermissions('create-folder');
        }else{
            return this.checkPermissions('create-folder')
        }

    }



}
